<template>
    <section class="w-100 row-12">
        <h2 class="col-12 m-b-0">Twoje katalogi</h2>
        <small class="col-12 m-b-0">Katalogi mają na celu pomóc Ci w grupowaniu Twoich prac</small>
        <div class="col-12 folderContainer">
            <div class="folder" :class="'folder-'+folder.id" v-for="folder in folderList" :key="folder.id">
                <div class="folder-action folder-edit" @click.prevent="initEditFolder(folder,$event)">
                    <i class="i-compose"></i>
                </div>
                <div class="folder-action folder-remove" @click.prevent="initRemoveFolder(folder.id,$event)">
                    <i class="i-cross"></i>
                </div>
                <div class="folder-icon" @click.prevent="activateFolder(folder)">
                    <img :src="folderImg" :alt="folder.name">
                    <div class="folder-counter">{{folder.count}}</div>
                </div>
                <div class="folder-name" @click.prevent="activateFolder(folder)">
                    {{folder.name}}
                </div>
            </div>

            <div class="folder add-new-folder" @click.prevent="showModal('#folder-modal-add')">
                <div class="folder-icon">
                    +
                </div>
                <div class="folder-name">
                    Dodaj nowy folder
                </div>
            </div>
        </div>

        <section id="folder-modal-add" class="modal" style="max-width: 400px;">
            <div class="modal-header">Dodaj nowy folder</div>
            <div class="modal-body">
                <p class="p-x-5">Folder pozwoli Ci lepiej pogrupować Twoją pracę. Nie ma żadnego limitu, twórz je do
                    woli.</p>
                <form @submit.prevent="addFolder">
                    <label for="folderName">Nazwa folderu</label>
                    <input id="folderName" v-model="newFolder.name" placeholder="Nazwa folderu" autofocus required/>
                </form>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click.prevent="hideModal('#folder-modal-add')">Anuluj</button>
                <button @click.prevent="addFolder()">Dodaj folder</button>
            </div>
        </section>

        <section id="folder-modal-remove" class="modal" style="max-width: 400px;">
            <div class="modal-header">Usuwanie folderu</div>
            <div class="modal-body">
                <p class="p-x-5">Jesteś pewny, że chcesz usunąć folder? <b>Wiąże się to z trwałym usunięciem jego całej
                    zawartości. Przemyśl czy na pewno to chcesz zrobić.</b></p>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click.prevent="hideModal('#folder-modal-remove')">Anuluj</button>
                <button @click.prevent="removeFolder()">Usuń folder</button>
            </div>
        </section>

        <section id="folder-modal-edit" class="modal" style="max-width: 400px;">
            <div class="modal-header">Edycja folderu</div>
            <div class="modal-body">
                <form @submit.prevent="editFolder">
                    <label for="editedFolderName">Nowa nazwa folderu</label>
                    <input id="editedFolderName" v-model="editedFolder.name" placeholder="Nazwa folderu" autofocus
                           required/>
                </form>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click.prevent="hideModal('#folder-modal-edit')">Anuluj</button>
                <button @click.prevent="editFolder()">Edytuj folder</button>
            </div>
        </section>
    </section>
</template>

<script>
    import folderImage from '../assets/folder.svg'

    export default {
        name: "FolderList",
        props: {
            autoSelect:{
                type: Boolean,
                default: true
            },
            folderType: {
                type: String,
                default: "animations"
            }
        },
        data: function () {
            return {
                newFolder: {
                    name: '',
                    type: this.folderType
                },
                editedFolder: {
                    name: '',
                    type: this.folderType
                },
                folderImg: folderImage,
                folderList: [],
                activeFolder: null
            }
        },
        methods: {
            getActiveFolder() {
                return this.activeFolder;
            },
            setFolderActive(id) {
                let isSelect = false;
                this.folderList.map((folder) => {
                    if (folder.id == id) {
                        this.activateFolder(folder);
                        isSelect = true;
                    }
                });
                if(!isSelect){
                    this.activateFolder(null);
                }
            },
            activateFolder(folder) {
                $('.folder').removeClass('actived');
                this.activeFolder = folder;
                this.$emit('select-folder', this.getActiveFolder());

                if(folder !== null){
                    $('.folder-' + folder.id).addClass('actived');
                }
            },
            selectFirst(){
                if (this.folderList.length > 0) {
                    this.setFolderActive(this.folderList[0].id);
                }else{
                    this.setFolderActive(null);
                }
            },
            getAllFolders() {
                axios.get(`folders/${this.folderType}`)
                    .then((response) => {
                        this.folderList = response.data;
                        if(this.autoSelect){
                            setTimeout(() => {
                                this.selectFirst()
                            }, 500);
                        }
                    })
            },
            addFolder() {
                try {
                    new Validator({
                        "nazwa folderu": this.newFolder.name
                    })
                        .get("nazwa folderu").length(3, 255)
                }
                catch (err) {
                    return false;
                }

                axios.post(`folders`, this.newFolder)
                    .then((response) => {
                        let newFolder = $.extend({}, this.newFolder);
                        newFolder.id = response.data;
                        newFolder.count = 0;
                        this.folderList.push(newFolder);

                        notify.createNotifier('Twój folder został dodany', 'success');
                        this.newFolder.name = '';
                        this.hideModal("#folder-modal-add");

                        if(this.autoSelect){
                            this.selectFirst()
                        }
                    })
            },
            initRemoveFolder(folderId, event) {
                if (event) event.preventDefault();
                this.showModal('#folder-modal-remove');
                this.folderRemoveId = folderId;
            },
            removeFolder() {
                axios.delete(`folders/${this.folderRemoveId}`)
                    .then((response) => {
                        notify.createNotifier('Twój folder został usunięty', 'success');
                        this.folderList = this.folderList.filter((folder) => {
                            return folder.id !== this.folderRemoveId
                        });
                        this.hideModal("#folder-modal-remove");
                        if(this.autoSelect){
                            this.selectFirst()
                        }
                    })
            },
            initEditFolder(folder, event) {
                if (event) event.preventDefault();
                this.showModal('#folder-modal-edit');
                this.editedFolder = $.extend({}, folder);
            },
            getContent() {
                let self = this;
                return new Promise(function (resolve, reject) {
                    if (self.activeFolder && self.activeFolder.id >= 0) {
                        axios.get(`folders/${self.activeFolder.id}/content`)
                            .then((response) => {
                                resolve(response.data);
                            })
                    }else{
                        resolve([]);
                    }
                });
            },
            editFolder() {
                try {
                    new Validator({
                        "nazwa folderu": this.editFolder.name
                    })
                        .get("nazwa folderu").length(3, 255)
                }
                catch (err) {
                    return false;
                }

                axios.put(`folders/${this.editedFolder.id}`, this.editedFolder)
                    .then((response) => {

                        this.folderList.map((folder) => {
                            if (folder.id === this.editedFolder.id) {
                                folder.name = this.editedFolder.name;
                            }
                        });

                        notify.createNotifier('Twój folder został zmieniony', 'success');
                        this.editedFolder.name = '';
                        this.hideModal("#folder-modal-edit");
                    })
            },
            reset(){
                this.getAllFolders();
            }
        },
        mounted: function () {
            this.getAllFolders();
        }
    }
</script>

<style scoped lang="scss">

    .folder-action {
        position: absolute;
        top: 5px;
        opacity: 0;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        color: #fff;
        text-align: center;
        transition: all .3s;
        z-index: 1;

        &:hover {
            transform: scale(1.2);
        }

        i {
            font-size: 10px;
            line-height: 20px;
            font-weight: bolder;
        }

        @media(max-width: 1200px) {
            opacity: 1;
            top: -5px;
        }
    }

    .folder-edit {
        left: -5px;
        background-color: #2c85bd;
    }

    .folder-remove {
        right: -5px;
        background-color: #c85740;
    }

    .folderContainer {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        transition: all .3s;

        @media(max-width: 1200px) {
            justify-content: center;
        }
    }

    .folder.actived {
        border: 1px solid #ababab;
    }

    .add-new-folder {
        background: #dddddd;

        .folder-icon {
            text-align: center;
            padding: 12px;
            font-weight: 100;
            font-size: 2rem;
        }
    }

    .folder {
        position: relative;
        user-select: none;
        border: 1px solid transparent;
        border-radius: 5px;
        padding: 5px 2px;
        width: 75px;
        margin: 15px;
    }

    .folder-name {
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        text-align: center;
        font-size: 14px;
    }

    .folder-icon {
        position: relative;
        img {
            width: 100%;
            padding: 0 10px 5px;
            box-sizing: border-box;
        }

        .folder-counter {
            position: absolute;
            top: 55%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
            font-weight: 100;
        }
    }

    .folder:hover {
        cursor: pointer;

        .folder-action {
            top: -5px;
            opacity: 1;
        }

        .folder-icon {
            transform: scale(1.1);
        }
    }

    .add-new-folder:hover {
        cursor: pointer;

        .folder-icon {
            transform: scale(1.5) rotate(90deg);
        }
    }
</style>